<template>
  <Accordion :error="$v.products.$error" id="products" title="PRODUTOS">
    <b-row class="row-padding pb-0">
      <b-col md="4" lg="5">
        <SelectWithSearch
          label="Produto"
          labelBusca="description"
          placeholder="Pesquise um produto"
          ref="searchProduct"
          v-model="product"
          :filterBy="productFilter"
          :error="$v.products.productOfPurchaseCollection.$error"
          :options="productCollection"
          :change="changeProduct"
          :search="searchProduct"
        >
          <template slot="no-options">Nenhum produto encontrado</template>
          <template slot="options" slot-scope="props">
            <div class="selected" style="text-transform: uppercase;">
              {{ props.data.description }} <br />
              R$:
              {{ valorReal(props.data.cost, decimalConfiguration.price) }}
              <br />
              Qtd:
              {{ valorReal(props.data.quantity, decimalConfiguration.quantity) }}
            </div>
          </template>
          <template slot="selected" slot-scope="props">
            <div class="selected" style="text-transform: uppercase;">
              {{ props.data.description }}
            </div>
          </template>
        </SelectWithSearch>
      </b-col>
      <b-col md="4" lg="2">
        <InputQuantity
          ref="quantityPurchased"
          id="quantityPurchased"
          label="Quantidade:"
          inputClass="form-control input"
          labelBold
          v-model="product.quantityPurchased"
          :max="13"
        />
      </b-col>
      <b-col md="4" lg="2">
        <InputMoney
          ref="unitPrice"
          id="unitPrice"
          label="Unitário:"
          inputClass="form-control input"
          v-model="product.price"
          :prefix="false"
          labelBold
          :max="11"
        />
      </b-col>
      <b-col md="6" lg="2">
        <InputMoney
          ref="quantityPurchased"
          id="quantityPurchased"
          label="Total:"
          inputClass="form-control input"
          :value="round(product.totalPrice, decimalPrice)"
          :prefix="false"
          labelBold
          disabled
        />
      </b-col>
      <b-col md="6" lg="1">
        <br />
        <Button
          type="success"
          class="pl-4 pr-4"
          @click="setProductOfPurchaseCollection()"
          :disabled="!isValidProduct || addingProduct"
        >
          <b-spinner small v-if="addingProduct"></b-spinner>
          <PlusThick v-else class="mr-0" title="Adicionar" />
        </Button>
      </b-col>
    </b-row>
    <div class="border-bottom m-2 mt-3 mb-3" />
    <b-row
      class="table-list-products row-padding pt-0"
      v-if="products.productOfPurchaseCollection.length"
    >
      <b-col class="busca">
        <table class="table">
          <thead>
            <tr>
              <th md="4" lg="5">Produto</th>
              <th md="4" lg="2" class="text-center">Quantidade</th>
              <th md="4" lg="2" class="text-center">CFOP</th>
              <th md="4" lg="2" class="text-center">Unitário</th>
              <th md="6" lg="2" class="text-center">Total</th>
              <th md="6" lg="1" class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            <Product
              v-for="(product, key) in products.productOfPurchaseCollection"
              :id="key"
              :key="key"
              :product="product"
            />
          </tbody>
        </table>
      </b-col>
    </b-row>
  </Accordion>
</template>

<script>
import _ from 'lodash';
import { Accordion } from '@/components';
import { mapState, mapActions, mapGetters } from 'vuex';
import { SelectWithSearch, Button, InputQuantity, InputMoney } from '@/components/Form';
import { required } from 'vuelidate/lib/validators';
import { CalcTypesPurchaseEnum } from '@/modules/Fiscal/enums/CalcTypesEnum';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import NumbersMixin from '@/modules/Application/mixins/NumbersMixin';
import PlusThick from 'vue-material-design-icons/PlusThick';
import MathUtils from '@/reusable/mathUtils';
import Product from './Product.vue';
import * as parser from '../../../parsers/edit-product';
import { orderTypeEnum } from '../../../../Shared/enums/orderTypeEnum';

export default {
  name: 'Products',
  components: {
    Accordion,
    SelectWithSearch,
    Button,
    Product,
    InputQuantity,
    InputMoney,
    PlusThick,
  },
  mixins: [FormatMixin, NumbersMixin],
  data() {
    return {
      decimalPrice: 2,
      decimalQuantity: 2,
      product: [],
      addingProduct: false,
      productFilter: _.debounce(async (option, search) => {
        console.log(search, 'search');
        const temp = search.toLocaleLowerCase();
        const description = option.description.toLocaleLowerCase();
        return description.includes(temp);
      }, 350),
    };
  },
  validations: {
    products: {
      productOfPurchaseCollection: {
        required,
      },
    },
  },
  async mounted() {
    this.getConfigEmissor();
    await this.setDefaultQuantity();
    await this.setProductCollection({ orderType: orderTypeEnum.PURCHASE });
  },
  computed: {
    ...mapState('product', ['productCollection', 'productInventory']),
    ...mapState('purchase', [
      'products',
      'purchaseParams',
      'taxInformation',
      'supplierInformation',
      'productOfPurchaseOnFiscalEdit',
      'matchedCfopForProductPurchase',
    ]),
    ...mapGetters('purchase', [
      'getDefaultProductOfPurchaseOnFiscalEditState',
      'decimalConfiguration',
    ]),
    isValidProduct() {
      return this.product.totalPrice >= 0.01;
    },
  },
  methods: {
    ...mapActions('product', ['setProductCollection', 'setProductInventory', 'resetProductCollection']),
    ...mapActions('purchase', [
      'totalCalcPurchase',
      'setRemainder',
      'setNaturezaError',
      'setSupplierError',
      'setMatchedCfopForProductPurchase',
    ]),
    ...mapActions('componentsPurchase', ['setLoadingTabProduct', 'setLoadingTabPurchase']),
    toggleAddingProductLoader() {
      this.addingProduct = !this.addingProduct;
    },
    setDefaultQuantity() {
      this.product.quantityPurchased = this.valorReal(1, this.decimalConfiguration.quantity);
    },
    setEmptyProduct() {
      this.product = [];
      this.setDefaultQuantity();
    },
    async getConfigEmissor() {
      if (window.localStorage.getItem('configurationEmissor')) {
        const configEmissor = await JSON.parse(window.localStorage.getItem('configurationEmissor'));
        this.decimalPrice = configEmissor.decimalPrice;
        this.decimalQuantity = configEmissor.decimalQuantity;
      }
    },
    async searchProduct(search) {
      if (!search.length) {
        this.resetProductCollection();
        return;
      }
      await this.setProductCollection({ search, orderType: orderTypeEnum.PURCHASE });
    },
    changeProduct(selectedProduct) {
      if (selectedProduct) {
        this.product = {
          ...this.product,
          ...selectedProduct,
          price: this.valorReal(selectedProduct.cost, this.decimalConfiguration.price),
        };

        return;
      }

      this.setEmptyProduct();
    },
    headerCFOPAndSupplierInformed() {
      const response = { isInformed: false, error: null };

      if (!this.taxInformation.natureza.cfop.codigo) {
        this.setNaturezaError(true);
        return { ...response, error: 'Natureza não informada' };
      }
      if (!this.supplierInformation.supplier.name) {
        this.setSupplierError(true);
        return { ...response, error: 'Fornecedor não informado' };
      }

      return { ...response, isInformed: true };
    },
    async buildCfop() {
      await this.setMatchedCfopForProductPurchase({
        supplierId: this.supplierInformation.supplier.id,
        cfopIdPurchaseHeader: this.taxInformation.natureza.cfop.id,
      });
    },
    async setProductOfPurchaseCollection() {
      try {
        const { isInformed, error } = this.headerCFOPAndSupplierInformed();
        if (!isInformed) {
          this.$alert.error(error);
          return;
        }

        this.toggleAddingProductLoader();
        await this.buildCfop();
        await this.setProductInventory(this.product.id);

        const { productOfPurchaseCollection } = this.products;
        const productInventoryFiscal = {
          ...this.productInventory.fiscal.produto,
          CFOP: { ...this.matchedCfopForProductPurchase },
        };
        const serializedFiscal = parser.inventoryProductFiscalInformation(productInventoryFiscal);

        productOfPurchaseCollection.push({
          ...this.product,
          edited: false,
          id: undefined,
          productId: this.product.id,
          quantityPurchased: this.valorUS(this.product.quantityPurchased),
          price: this.valorUS(this.product.price),
          fiscal: serializedFiscal,
        });

        await this.totalCalcPurchase({
          calcTypes: [
            CalcTypesPurchaseEnum.TOTAL_ATTRIBUTES,
            CalcTypesPurchaseEnum.TOTAL_COMMON,
            CalcTypesPurchaseEnum.TOTAL_DESC_BASED_ON_ITEM,
            CalcTypesPurchaseEnum.TOTAL_NF,
          ],
        });
        this.setEmptyProduct();
        this.toggleAddingProductLoader();
      } catch {
        this.toggleAddingProductLoader();
      }
    },
  },
  watch: {
    product: {
      handler() {
        const price = this.valorUS(this.product.price);
        const quantity = this.valorUS(this.product.quantityPurchased);
        this.product.totalPrice = new MathUtils(price).multiply(quantity).toNumber();
      },
      deep: true,
    },
    products: {
      async handler() {
        await this.setRemainder();
      },
      deep: true,
    },
  },
};
</script>

<style>
.table-list-products {
  max-height: 400px !important;
  overflow: auto !important;
}
</style>
